import { SplitColumnsContainer } from '@startlibs/components'
import { Combobox, FormValue, SimpleCheckbox, TextInput, useFormValue } from '@startlibs/form'
import { getColor } from '@startlibs/utils';
import React from 'react'
import styled from 'styled-components';
import { Card, SectionHeading } from '../../components/PageLayout';
import { REF_PHYSICIAN } from '../../enums/ContactRelationType'
import { ConfirmEmailInput } from '../../components/ConfirmEmailInput'
import { getFormattedStates } from '../PatientAndContactDetails';
import { ComboboxContainer } from './ContactDetails';
import StyledTelInput from '../../components/StyledTelInput';
import { FormattedMessage, useIntl } from 'react-intl';

export const AddressHeading = styled.div`
  font-size: 13px;
  color: ${getColor('gray150')};
  padding-bottom: .25rem;
  border-bottom: 1px solid ${getColor('gray210')};
  margin: 1.5rem 0;
`

const VIEWPORT_MIN_WIDTH = 500

export const ReferringPhysician = ({ readOnly, isAdmin, form, countryList, showSelects,
  refphysicianPhoneNumberValid, setRefphysicianPhoneNumberValid,
  refphysicianFaxNumberValid, setRefphysicianFaxNumberValid
 }) => {

  const [relationType] = useFormValue('contactDetails.contactRelationType')
  const intl = useIntl()

  if (relationType === REF_PHYSICIAN) {
    return null
  }

  return <>
    <SectionHeading>
      <h3><FormattedMessage defaultMessage="Referring physician" description="Contact relation label: Referring physician" /></h3>
      <p>
        <FormattedMessage 
          defaultMessage="This physician can be requested to take action on this case and may receive a copy of any resulting reports." 
          description="Physician can be requested description"
        />
      </p>
    </SectionHeading>
    <Card css="padding-bottom:1.5rem;">
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">

        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.fullName.first"
          label={intl.formatMessage({ defaultMessage: "First name", description: "Physician step first name" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: John", description: "Physician step first name" })}
          maxLength={255}
        />

        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.fullName.last"
          label={intl.formatMessage({ defaultMessage: "Last name", description: "Physician step last name" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: Doe", description: "Physician step last name" })}        
          maxLength={255}
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.institution"
          label={intl.formatMessage({ defaultMessage: "Institution", description: "Physician step institution" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: Purview", description: "Physician step institution" })}      
          maxLength={255}
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        {showSelects ? <>
          <ComboboxContainer readOnly={readOnly} className='fs-exclude'><Combobox
            disabled={readOnly}
            className="combobox fs-exclude"
            label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Please select country", description: "PatientDetails country select placeholder" })}       
            path='referringPhysician.address.country'
            options={countryList}
            onChange={(val) => {
              var states = getFormattedStates(val)
              if (states.length > 0) {
                if (states.findIndex(x => x === form.getValue('referringPhysician.address.state')) == -1) {
                  form.setValue('referringPhysician.address.state', null)
                }
              }
            }}
          /></ComboboxContainer>
          <FormValue path="referringPhysician.address.country">{country =>
            <ComboboxContainer readOnly={readOnly} className='fs-exclude'>
              <Combobox
                disabled={readOnly}
                className="combobox fs-exclude"
                label={intl.formatMessage({ defaultMessage: "State/Province", description: "PatientDetails state label" })}
                placeholder={intl.formatMessage({ defaultMessage: "Please select state", description: "PatientDetails state select placeholder" })}
                path='referringPhysician.address.state'
                options={getFormattedStates(country)}
              />
            </ComboboxContainer>
          }</FormValue>
        </> : <>
          <TextInput
            disabled={readOnly}
            type="text"
            path="referringPhysician.address.country"
            label={intl.formatMessage({ defaultMessage: "Country", description: "PatientDetails country label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: USA", description: "PatientDetails country placeholder" })}
            maxLength={255}
          />
          <TextInput
            disabled={readOnly}
            type="text"
            path="referringPhysician.address.state"
            label={intl.formatMessage({ defaultMessage: "State", description: "PatientDetails state label" })}
            placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails state placeholder" })}
            maxLength={255}
          />
        </>}
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.address.city"
          label={intl.formatMessage({ defaultMessage: "City", description: "PatientDetails city label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: New York", description: "PatientDetails city placeholder" })}
          maxLength={255}
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.address.zipCode"
          label={intl.formatMessage({ defaultMessage: "Postal code", description: "PatientDetails postal code label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 12345", description: "PatientDetails postal code placeholder" })}
          maxLength={255}
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.address.address"
          label={intl.formatMessage({ defaultMessage: "Street address - Line 1", description: "PatientDetails street address line 1 label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 001 Street Name", description: "PatientDetails street address line 1 placeholder" })}
          maxLength={255}
        />
        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.address.address2"
          label={intl.formatMessage({ defaultMessage: "Street address - Line 2", description: "PatientDetails street address line 2 label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: PO BOX 001", description: "PatientDetails street address line 2 placeholder" })}
          maxLength={255}
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
        <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.email"
          label={intl.formatMessage({ defaultMessage: "Email address", description: "Physician email address label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: physicians@email.com", description: "Physician email address placeholder" })}
          maxLength={255}
        />
        <ConfirmEmailInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.confirmEmail"
          confirmingPath="referringPhysician.email"
          label={intl.formatMessage({ defaultMessage: "Confirm email", description: "Physician confirm email address label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: physicians@email.com", description: "Physician email address placeholder" })}
          maxLength={255}
          mandatory={false}
        />
      </SplitColumnsContainer>
      <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">

        <StyledTelInput
          path="referringPhysician.phoneNumber"
          label={intl.formatMessage({ defaultMessage: "Phone number", description: "ContactDetails phone number label" })}
          placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails phone number placeholder" })}
          hasErrors={form.hasErrors()}
          disabled={readOnly}
          initOptions={{
            initialCountry: "us",
            separateDialCode: false,
            autoPlaceholder: "aggressive",
            formatOnDisplay: true,
            placeholderNumberType: "FIXED_LINE_OR_MOBILE",
            nationalMode: false,
            countryOrder: ["us"]
          }}
          tabIndex={1}
          isValid={refphysicianPhoneNumberValid}
          setIsValid={setRefphysicianPhoneNumberValid}
        />
        <StyledTelInput
          path="referringPhysician.faxNumber"
          hasErrors={form.hasErrors()}
          disabled={readOnly}
          label={intl.formatMessage({ defaultMessage: "Fax number", description: "ContactDetails fax number label" })}
          placeholder={intl.formatMessage({ defaultMessage: "(201) 555-0123", description: "ContactDetails fax number placeholder" })}
          initOptions={{
            initialCountry: "us",
            separateDialCode: false,
            autoPlaceholder: "aggressive",
            formatOnDisplay: true,
            placeholderNumberType: "FIXED_LINE_OR_MOBILE",
            nationalMode: false,
            countryOrder: ["us"]
          }}
          tabIndex={1}
          isValid={refphysicianFaxNumberValid}
          setIsValid={setRefphysicianFaxNumberValid}
        />
        {isAdmin && <TextInput
          disabled={readOnly}
          type="text"
          path="referringPhysician.npi"
          label={intl.formatMessage({ defaultMessage: "NPI", description: "ContactDetails npi label" })}
          placeholder={intl.formatMessage({ defaultMessage: "Ex: 1234567890", description: "ContactDetails npi placeholder" })}
          maxLength={255}
        // mandatory
        />}

      </SplitColumnsContainer>
      <FormValue path="referringPhysician.acceptContact">{acceptContact =>
        acceptContact !== null && <>
          {isAdmin && <SplitColumnsContainer viewportMinWidth={VIEWPORT_MIN_WIDTH} margin="big">
            <SimpleCheckbox
              disabled={readOnly}
              path="referringPhysician.acceptContact"
              label={<span css="font-size:13px;">
                <FormattedMessage
                  defaultMessage={"This physician has been made aware of this case, and can be contacted as necessary"}
                  description={"Physician made aware accept contact label"}
                />
              </span>}
            />
          </SplitColumnsContainer>}
        </>}
      </FormValue>
    </Card>
  </>
}
